<template>
    <popup-modal
        :title="title"
        :description="description"
        :title-border="false"
        @close="close"
    >

        <add-component-selector v-if="selectingComponent"></add-component-selector>

    </popup-modal>
</template>

<script>
import { mapState } from 'pinia'
import {useBrandingStore} from '../../../shared/state/branding';

import PopupModal from './PopupModal.vue';
import AddComponentSelector from './AddComponentSelector.vue';

export default {
    components: {
        'popup-modal': PopupModal,
        'add-component-selector': AddComponentSelector,
    },
    methods: {
        close () {
            this.$emit('close');
        }
    },
    computed: {
        ...mapState(useBrandingStore, [ 'addingComponent' ]),
        selectingComponent () {
            return typeof this.addingComponent.type === 'undefined';
        },
        title () {
            return this.$t('site_editor.selector.title');
        },
        description () {
            return this.$t('site_editor.selector.description');
        }
    }
}
</script>
